'use es6';

export function isHalloween(theme) {
  return theme && theme.name === 'halloween';
}